import React from 'react';
import logoMark from '../assets/logo/Generated_Image_April_11__2026_-_11_08AM-removebg-preview.png';

const GOLD = '#C8A96A';

/**
 * Crest from brand PNG (top crop) + wordmark: JATIN (white), INTERIORS (gold).
 */
const BrandLogoLockup = ({ variant = 'nav' }) => {
  const isNav = variant === 'nav';
  const crestBox = isNav
    ? 'h-10 w-12 sm:h-12 sm:w-14 md:h-14 md:w-[3.75rem]'
    : 'h-12 w-14 sm:h-14 sm:w-16 md:h-16 md:w-[4.25rem]';
  const jatinClass = isNav
    ? 'text-lg sm:text-xl md:text-2xl'
    : 'text-xl sm:text-2xl md:text-3xl';
  const interiorsClass = isNav ? 'text-[0.62rem] sm:text-xs mt-0.5' : 'text-xs sm:text-sm mt-1';

  return (
    <div className="flex items-center gap-2 sm:gap-3">
      <div className={`relative shrink-0 overflow-hidden rounded-sm ${crestBox}`}>
        <img
          src={logoMark}
          alt=""
          aria-hidden
          className="pointer-events-none absolute left-1/2 top-0 h-[175%] w-auto min-w-[108%] max-w-none -translate-x-1/2 select-none object-cover object-top"
        />
      </div>
      <div className="flex min-w-0 flex-col justify-center leading-none text-left">
        <span className={`font-bold tracking-tight text-white brand-font ${jatinClass}`}>JATIN</span>
        <span
          className={`font-semibold uppercase tracking-[0.22em] ${interiorsClass}`}
          style={{ color: GOLD }}
        >
          INTERIORS
        </span>
      </div>
    </div>
  );
};

export default BrandLogoLockup;
